module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "article-wrapper"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', {
    staticClass: "article-type text-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.article.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "article-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-219eb88e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/article.vue
// module id = 337
// module chunks = 1